import { AppConfigModel } from '@retail-portal-santander-frontend/app-config';

export const environment: AppConfigModel = {
  production: false,
  baseURL: 'https://santander-cil-bff.api.test.allianzretailportal.com',
  paymentUrl: 'https://payment-page.uat.aws.emagin.eu/#/payment/',
  metaportalUrl: 'https://test.santander.allianz-partners.com/',
};
